import { Component, Inject, OnInit, OnDestroy, Injectable, Input } from '@angular/core';
import { Subscription, Observable } from 'rxjs';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA, MatSnackBar } from '@angular/material/snack-bar';
import { tools } from '../services/tools';

import { AlertService } from '../services/alert.service';
import { deviceService } from '../servicesHardware/deviceService';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'alert',
  template: ``,
})
export class AlertComponent implements OnInit, OnDestroy {
  private subscription: Subscription | undefined;
  message: any;
  public iframeContent: string = '';
  private snackBarIsClosed: boolean = true;
  private subscriptionSnackBarClosed: Subscription | undefined = undefined;

  private isEmbeddedInIframe: boolean = false;

  constructor(
    private alertService: AlertService,
    public snackBar: MatSnackBar,
    private deviceService: deviceService,
  ) {
    let ancestor = document.location?.ancestorOrigins;
    if (ancestor != undefined && ancestor.length > 0 && (ancestor[0].includes('apps.digit4ll.') || ancestor[0].includes('devlocal:4204')))
      this.isEmbeddedInIframe = true;
  }

  ngOnInit() {
    this.subscription = this.alertService.getMessage().subscribe((message) => {
      let delay: number = 0;
      let messageDisplay: string = '';
      delay = 8000;
      if (message != null) {
        messageDisplay = message.text;
        if (message.delay != null) delay = message.delay;
      }
      if (message != null && message.type == 'error') {
        message = message.text;
        delay = message.delay;
        switch (message.subType) {
          case 'timeOut':
            delay = 3500;
            messageDisplay = 'Connexion au serveur impossible : Mode hors ligne';
            break;
          case '401':
            delay = 0;
            messageDisplay = 'Votre session a expiré, veuillez vous reconnecter';
            this.logout();
            break;
          case '404':
            delay = 8000;
            if (message?.error?.detail != null)
              messageDisplay = 'Erreur : ' + message.error?.status + ', ' + message.error?.title + ', (' + message.error?.detail + ')';
            else messageDisplay = "impossible d'accéder au service " + message.message + ' Contacter le support';
            break;
          case '400':
            delay = 8000;
            messageDisplay = 'Erreur : ' + message.error?.status + ', ' + message.error?.title + ', (' + message.error?.detail + ')';
            break;
          default:
            delay = 5000;
            if (message?.error?.detail != null)
              messageDisplay = 'Erreur : ' + message.error?.status + ', ' + message.error?.title + ', (' + message.error?.detail + ')';
            if (message.message != null && message.message != '') messageDisplay = message.message;
            else messageDisplay = message.toString();
            break;
        }
        if (delay != 0) {
          if (this.snackBarIsClosed == true) this.openSnackBar(messageDisplay, delay);
        }
      } else if (message != null && message.type == 'success') {
        this.openSnackBarSucces(messageDisplay, delay);
      } else if (message != null && message.type == 'info') {
        this.openSnackBarInfos(messageDisplay, delay);
      } else if (message != null && message.type == 'smallInfo') {
        this.openSmallSnackBarInfos(messageDisplay, delay);
      } else if (message != null && message.type == 'warn') {
        this.openSnackBarWArn(messageDisplay, delay);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription != undefined) this.subscription.unsubscribe();
    if (this.subscriptionSnackBarClosed != undefined) this.subscriptionSnackBarClosed.unsubscribe();
  }

  openSnackBar(message: string, delay: number) {
    this.snackBar.openFromComponent(errorSnackBar, {
      duration: delay,
      data: { message, delay },
      panelClass: ['root-snackbar-error', 'root-snackbar'],
    });
  }

  private async logout() {

    try {
      localStorage.removeItem('userSession');
      localStorage.removeItem('currentUserLogin');
    } catch (e) {
      console.log(e);
    }
  }

  public openSnackBarSucces(message: string, delay: number) {
    this.snackBar.openFromComponent(succesSnackBar, {
      duration: delay,
      data: { message, delay },
      panelClass: ['root-snackbar-success', 'root-snackbar'],
    });
  }

  public openSnackBarInfos(message: string, delay: number) {
    this.snackBar.openFromComponent(infosSnackBar, {
      duration: delay,
      data: { message, delay },
      panelClass: ['root-snackbar-info', 'root-snackbar'],
    });
  }

  public openSnackBarWArn(message: string, delay: number) {
    this.snackBar.openFromComponent(warnSnackBar, {
      duration: delay,
      data: { message, delay },
      panelClass: ['root-snackbar-warn', 'root-snackbar'],
    });
  }

  public openSmallSnackBarInfos(message: string, delay: number) {
    this.snackBar.openFromComponent(smallInfosSnackBar, {
      duration: delay,
      data: { message, delay },
      panelClass: ['root-snackbar-small', 'root-small-snackbar'],
    });
  }

  public closeSnackBar() {
    this.snackBar.dismiss();
  }
}

@Component({
  selector: 'error-bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'error.component.html',
  styleUrls: ['alert.scss']
})
@Injectable({
  providedIn: 'root',
})
export class errorBar implements OnInit {
  @Input() public message: any;
  public data: any = {};
  public displayCloseBtn: boolean = false;
  constructor() { }
  ngOnInit(): void {
    this.data['message'] = this.message;
  }
  public close() {
    console.log('test');
    // this.sncackBarRef.dismiss();
  }
}

// error cmp
@Component({
  selector: 'error-Snack-Bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'error.component.html',
  styleUrls: ['alert.scss']
})
@Injectable({
  providedIn: 'root',
})
export class errorSnackBar {
  public countPercent: number = 100;
  public displayCloseBtn: boolean = true;
  public indeterminate: boolean = false;

  constructor(
    private sncackBarRef: MatSnackBarRef<errorSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    if (data.delay == 0) this.indeterminate = true;
    else this.progressBarValue(data.delay / 50);
  }

  private async progressBarValue(time: number) {
    let count = JSON.parse(JSON.stringify(time));
    while (count > 1) {
      count--;
      this.countPercent = (count * 100) / time;
      await this.delay(50);
    }
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise((resolve) => setTimeout(() => resolve(true), delayInMs)).then(() => {
      return true;
    });
  }

  public close() {
    this.sncackBarRef.dismiss();
  }
}

// success cmp
@Component({
  selector: 'success-Snack-Bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'success.component.html',
  styleUrls: ['alert.scss']
})
@Injectable({
  providedIn: 'root',
})
export class succesSnackBar {
  public countPercent: number = 100;
  public indeterminate: boolean = false;

  constructor(
    private sncackBarRef: MatSnackBarRef<succesSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {

    if (data.delay == 0) this.indeterminate = true;
    else this.progressBarValue(data.delay / 50);
  }

  private async progressBarValue(time: number) {
    let count = JSON.parse(JSON.stringify(time));
    while (count > 1) {
      count--;
      this.countPercent = (count * 100) / time;
      await this.delay(50);
    }
  }

  public close() {
    console.log('closing');
    this.sncackBarRef.dismiss();
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise((resolve) => setTimeout(() => resolve(true), delayInMs)).then(() => {
      return true;
    });
  }
}

// infos cmp
@Component({
  selector: 'small-infos-Snack-Bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'small-infos.component.html',
  styleUrls: ['small-infos.component.scss']
})
@Injectable({
  providedIn: 'root',
})
export class smallInfosSnackBar {
  public countPercent: number = 100;
  public indeterminate: boolean = false;

  constructor(
    private sncackBarRef: MatSnackBarRef<smallInfosSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    if (data.delay == 0) this.indeterminate = true;
    else this.progressBarValue(data.delay / 50);
  }

  private async progressBarValue(time: number) {
    let count = JSON.parse(JSON.stringify(time));
    while (count > 1) {
      count--;
      this.countPercent = (count * 100) / time;
      await this.delay(50);
    }
  }

  public close() {
    this.sncackBarRef.dismiss();
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise((resolve) => setTimeout(() => resolve(true), delayInMs)).then(() => {
      return true;
    });
  }
}

// infos cmp
@Component({
  selector: 'infos-Snack-Bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'infos.component.html',
  styleUrls: ['alert.scss']
})
@Injectable({
  providedIn: 'root',
})
export class infosSnackBar {
  public countPercent: number = 100;
  public indeterminate: boolean = false;

  constructor(
    private sncackBarRef: MatSnackBarRef<infosSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    if (data.delay == 0) this.indeterminate = true;
    else this.progressBarValue(data.delay / 50);
  }

  private async progressBarValue(time: number) {
    let count = JSON.parse(JSON.stringify(time));
    while (count > 1) {
      count--;
      this.countPercent = (count * 100) / time;
      await this.delay(50);
    }
  }

  public close() {
    this.sncackBarRef.dismiss();
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise((resolve) => setTimeout(() => resolve(true), delayInMs)).then(() => {
      return true;
    });
  }
}

// warn cmp
@Component({
  selector: 'warn-Snack-Bar',
  standalone: true,
  imports: [MatIconModule, MatProgressBarModule, CommonModule, MatButtonModule],
  templateUrl: 'warn.component.html',
  styleUrls: ['alert.scss']
})
@Injectable({
  providedIn: 'root',
})
export class warnSnackBar {
  public countPercent: number = 100;
  public indeterminate: boolean = false;

  constructor(
    private sncackBarRef: MatSnackBarRef<warnSnackBar>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {

    if (data.delay == 0) this.indeterminate = true;
    else this.progressBarValue(data.delay / 50);
  }

  public close() {
    this.sncackBarRef.dismiss();
  }

  private async progressBarValue(time: number) {
    let count = JSON.parse(JSON.stringify(time));
    while (count > 1) {
      count--;
      this.countPercent = (count * 100) / time;
      await this.delay(50);
    }
  }

  async delay(delayInMs: number): Promise<any> {
    return new Promise((resolve) => setTimeout(() => resolve(true), delayInMs)).then(() => {
      return true;
    });
  }
}
